import { inventoryApi } from './api/inventory';
import { recommendationsApi } from './api/recommendations';
import { loyaltyApi } from './api/loyalty';
import { customerCareApi } from './api/customerCare';
import type { ApiProxyClient } from './types';
import { storesApi } from './api/stores';
import { accountApi } from './api/account';
import { discountsApi } from './api/discounts';
import { identityApi } from './api/identity';
import { cartApi } from './api/cart';
import { ordersApi } from './api/orders';

const apiProxyClient: ApiProxyClient = {
    account: accountApi,
    cart: cartApi,
    customerCare: customerCareApi,
    discounts: discountsApi,
    identity: identityApi,
    inventory: inventoryApi,
    loyalty: loyaltyApi,
    recommendations: recommendationsApi,
    stores: storesApi,
    orders: ordersApi,
};

export default apiProxyClient;
export * from './types';
